import React, { useState } from 'react';

import { sanitizeHtml } from '../../../utils/sanitizeHtml';
import InfoModal from '../../modals/InfoModal';

function GolfClubAbout({ club, aboutHtml }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasAboutBody = Boolean(aboutHtml && String(aboutHtml).trim());

  const createMarkup = () => {
    return { __html: sanitizeHtml(aboutHtml) };
  };

  const renderIntro = () =>
    club.club_name && club.club_type && club.club_county ? (
      <p>
        {club.club_name} is a {club.club_type.toLowerCase()}, in {club.club_county}.
        {club.club_formation &&
          ` The club was first formed in ${club.club_formation}.`}
      </p>
    ) : null;

  return (
    <section className="mx-auto mt-2 w-full lg:mt-1 xl:flex xl:min-h-0 xl:h-full xl:flex-col">
      <article
        id="golfClubAbout"
        className="flex h-full min-h-0 w-full flex-col overflow-y-hidden rounded-xl bg-white p-4 shadow-lg prose prose-sm sm:prose-md md:p-6 max-w-none text-left xl:flex-1"
      >
        <h3 className="flex-shrink-0 text-center">
          About: <span className="text-indigo-700">{club.club_name}</span>
        </h3>

        {renderIntro()}

        {hasAboutBody ? (
          <div className="mt-1 flex min-h-0 flex-1 flex-col">
            <div className="max-h-[200px] shrink-0 overflow-hidden lg:max-h-[320px]">
              <div dangerouslySetInnerHTML={createMarkup()} />
            </div>
            <div className="mt-auto w-full shrink-0 rounded-b-xl border-t border-gray-200 bg-white pt-2">
              <button
                type="button"
                className="w-full rounded-xl py-2 text-center text-sm text-indigo-600 underline transition duration-300 ease-in-out hover:text-indigo-800"
                onClick={() => setIsModalOpen(true)}
              >
                Read More...
              </button>
            </div>
          </div>
        ) : (
          <p className="mt-2">GolfLists research on this golf club is work in progress!</p>
        )}
      </article>

      {hasAboutBody ? (
        <InfoModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={`About: ${club.club_name}`}
        >
          <article className="prose prose-sm sm:prose-lg text-left max-w-none">
            {renderIntro()}
            <div dangerouslySetInnerHTML={createMarkup()} />
          </article>
        </InfoModal>
      ) : null}
    </section>
  );
}

export default GolfClubAbout;
